<gen-button *ngFor="let action of actions"
            [type]="action.type"
            [text]="action.text"
            [iconClass]="action.icon"
            (click)="action.callback()">
</gen-button>
